import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FacebookSDK } from 'components/FacebookSDK/FacebookSDK';

export class FacebookConnectButton extends PureComponent {
  /* istanbul ignore next */
  componentDidMount() {
    // eslint-disable-next-line no-underscore-dangle
    if (__CLIENT__ && !window._fbAuthResponse) {
      this.facebookReadyHandler = () => this.forceUpdate();
      document.body.addEventListener('facebookReady', this.facebookReadyHandler);
    }
  }

  /* istanbul ignore next */
  componentWillUnmount() {
    if (this.facebookReadyHandler) {
      document.body.removeEventListener('facebookReady', this.facebookReadyHandler);
      this.facebookReadyHandler = null;
    }
  }

  render() {
    const { children, ...rest } = this.props;

    const disabled = rest.disabled || __SERVER__ || (__CLIENT__ && !window._fbAuthResponse); // eslint-disable-line no-underscore-dangle

    return (
      <>
        <FacebookSDK />
        <button {...rest} disabled={disabled}>
          {children}
        </button>
      </>
    );
  }
}

FacebookConnectButton.propTypes = {
  children: PropTypes.node,
};
